import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Recover from stale dynamic-import chunks after a new deploy.
// When index.html cached on the client references a hash that no longer
// exists, the browser throws "Failed to fetch dynamically imported module".
// We hard-reload once (bypassing cache) so it picks up the fresh index.html.
const CHUNK_RELOAD_KEY = '__chunk_reload_attempt__';
const isChunkLoadError = (msg: string) =>
  /Failed to fetch dynamically imported module|Importing a module script failed|ChunkLoadError|Loading chunk [\d]+ failed/i.test(msg);

const tryRecover = (msg: string) => {
  if (!isChunkLoadError(msg)) return;
  const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
  // Avoid infinite reload loops: only retry once per minute.
  if (Date.now() - last < 60_000) return;
  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  window.location.reload();
};

window.addEventListener('error', (e) => tryRecover(e?.message || ''));
window.addEventListener('unhandledrejection', (e) => tryRecover(String((e as PromiseRejectionEvent)?.reason?.message || (e as PromiseRejectionEvent)?.reason || '')));


// Canonical host enforcement is handled by Lovable edge (apex -> www 301).
// Do NOT redirect in JS — it can fight the edge redirect and break the auth
// session (storage is per-host), causing reload loops after OAuth.

// Initialize theme from localStorage
const savedTheme = localStorage.getItem('theme');
if (savedTheme === 'dark' || (!savedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
  document.documentElement.classList.add('dark');
}

createRoot(document.getElementById("root")!).render(<App />);
